import { useCallback, useRef } from "react";

const useDebounceCallback = <T extends (...args: any[]) => any>(
	callback: T,
	delay = 400
) => {
	const timeout = useRef<number>();

	const debouncedCallback = useCallback(
		(...args: Parameters<T>) => {
			clearTimeout(timeout.current);
			timeout.current = setTimeout(() => {
				callback(...args);
			}, delay);
		},
		[callback, delay]
	);

	return debouncedCallback;
};

export default useDebounceCallback;
